// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "body, html {\n  margin: 0;\n  padding: 0;\n  font-family: \"Comfortaa\", cursive;\n}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA;EAEE,SAAA;EACA,UAAA;EACA,iCAAA;AAAF","file":"styles.scss","sourcesContent":["body, html {\n\n  margin: 0;\n  padding: 0;\n  font-family: 'Comfortaa', cursive;\n\n}\n"]}]);
// Exports
module.exports = exports;
